<script lang="ts" setup>
  import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '~/components/ui/tooltip'
  import { getFormattedAbsoluteDate, getTimeAgo } from '~/utils/date'

  defineProps<{ date: string }>()
  const { locale } = useI18n()
</script>

<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <p class="cursor-default text-content-muted w-fit hover:underline transition-all duration-300 text-xs">
          {{ getTimeAgo(new Date(date), locale) }}
        </p>
      </TooltipTrigger>
      <TooltipContent arrow side="top">
        <p class="text-white">{{ getFormattedAbsoluteDate(date, locale) }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<style scoped></style>
